import { frontendURL } from '../../../helper/URLHelper';
import ContaIndex from './pages/ContaIndex.vue';
import LogoutIndex from './pages/LogoutIndex.vue';
import DeleteAccountSuccessIndex from './pages/DeleteAccountSuccessIndex.vue';
import { laisCanonicalRedirect } from '../laisRouteHelpers';

const SELF_SERVICE_PERMISSIONS = ['administrator', 'agent', 'custom_role'];
const ADMIN_PERMISSIONS = ['administrator'];
const AGENCY_ADMIN_PERMISSIONS = ['administrator', 'agency_manage'];
const accountSectionRedirect = section =>
  laisCanonicalRedirect('conta_index', { params: { section } });

export const routes = [
  {
    path: frontendURL('accounts/:accountId/area-da-conta/:section?'),
    name: 'conta_index',
    component: ContaIndex,
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/meus-dados'),
    alias: [frontendURL('accounts/:accountId/minha-conta')],
    name: 'meus_dados_index',
    redirect: accountSectionRedirect('meus-dados'),
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/manual-do-usuario'),
    alias: [frontendURL('accounts/:accountId/manual')],
    name: 'manual_usuario_index',
    redirect: accountSectionRedirect('manual'),
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/area-do-corretor'),
    alias: [
      frontendURL('accounts/:accountId/corretor'),
      frontendURL('accounts/:accountId/vitrine-corretor'),
    ],
    name: 'corretor_vitrine_index',
    redirect: accountSectionRedirect('corretor'),
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/imobiliaria/perfil'),
    alias: [frontendURL('accounts/:accountId/perfil-imobiliaria')],
    name: 'imobiliaria_perfil_index',
    redirect: accountSectionRedirect('imobiliaria'),
    meta: { permissions: AGENCY_ADMIN_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/privacidade'),
    alias: [frontendURL('accounts/:accountId/politica-de-privacidade')],
    name: 'privacidade_index',
    redirect: accountSectionRedirect('privacidade'),
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/termos'),
    alias: [frontendURL('accounts/:accountId/termos-de-uso')],
    name: 'termos_index',
    redirect: accountSectionRedirect('termos'),
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/auth/logout'),
    alias: [frontendURL('accounts/:accountId/logout')],
    name: 'logout_index',
    component: LogoutIndex,
    meta: { permissions: SELF_SERVICE_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/deletar-conta'),
    alias: [frontendURL('accounts/:accountId/excluir-conta')],
    name: 'deletar_conta_index',
    redirect: accountSectionRedirect('deletar'),
    meta: { permissions: ADMIN_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/deletar-conta/sucesso'),
    alias: [frontendURL('accounts/:accountId/excluir-conta/sucesso')],
    name: 'deletar_conta_sucesso_index',
    component: DeleteAccountSuccessIndex,
    meta: { permissions: ADMIN_PERMISSIONS },
  },
];
